export default class ApiError {
  constructor(public message: string) {}
}
